// GHL (GoHighLevel / Foundrywave) — typed frontend client
// All calls route through Lovable edge functions. Never expose API keys here.

import { supabase } from "@/integrations/supabase/client";

export interface CreateGhlContactInput {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  /** Where the lead came from (page, form name, campaign). Defaults server-side. */
  source?: string;
  /** Tags to apply in GHL. Max 20, each ≤100 chars. */
  tags?: string[];
  /** Custom field values keyed by GHL field key. */
  customFields?: Record<string, string | number | boolean>;
}

export interface CreateGhlContactResult {
  success: true;
  contactId?: string;
  created?: boolean;
  updated?: boolean;
}

export interface GhlError {
  success: false;
  error: string;
}

/**
 * Creates (or updates if it already exists) a contact in GHL.
 * Either `email` or `phone` is required.
 */
export async function createGhlContact(
  input: CreateGhlContactInput
): Promise<CreateGhlContactResult | GhlError> {
  if (!input.email && !input.phone) {
    return { success: false, error: "Email or phone is required" };
  }

  const { data, error } = await supabase.functions.invoke("ghl-create-contact", {
    body: input,
  });

  if (error) {
    console.error("createGhlContact error", error);
    return { success: false, error: error.message ?? "Network error" };
  }

  if (data && typeof data === "object" && "error" in data) {
    return { success: false, error: String((data as { error: unknown }).error) };
  }

  return data as CreateGhlContactResult;
}
